// @flow
// $FlowFixMe
import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { globalQueryClient } from 'queries/queryClient'
import type { ReminderProps } from 'types/reminders'

import { QUERIES } from '@/enums/queries'

import { getGlobalReminder, listReminders } from './services/loadReminders'

export const useLoadReminders = (
  options: any = {}
  // $FlowFixMe
): UseQueryResult<ReminderProps[], Error> => {
  return useQuery({
    queryKey: [QUERIES.REMINDERS.LIST],
    queryFn: ({ signal }) => {
      return listReminders({ signal })
    },
    ...options,
  })
}

export const useLoadGlobalReminder = (
  options: any = {}
  // $FlowFixMe
): UseQueryResult<ReminderProps, Error> => {
  return useQuery({
    queryKey: [QUERIES.REMINDERS.GET_GLOBAL],
    queryFn: () => {
      return getGlobalReminder()
    },
    ...options,
  })
}

export const invalidateLoadReminders = () => {
  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.REMINDERS.LIST],
    exact: false,
  })

  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.REMINDERS.GET_GLOBAL],
    exact: false,
  })
}
